import React from 'react';
import { ShieldCheck, Zap, Palette, Ban, Sun, RefreshCw } from 'lucide-react';

const Services = () => {
  const pillars = [
    {
      icon: <ShieldCheck size={32} />,
      title: "100% Offline-First Privacy",
      description: "Our software products run computational engines locally on your device. Your photos, documents, notes, and project estimates are never harvested or sent to external cloud servers."
    },
    {
      icon: <Zap size={32} />,
      title: "Native Android Performance",
      description: "Built with Kotlin and modern Jetpack libraries for blazing speed, instant app startup, low RAM consumption, and smooth 120Hz display responsiveness."
    },
    {
      icon: <Palette size={32} />,
      title: "Material Design 3 & Clean UI",
      description: "Thoughtfully crafted interfaces following Material You guidelines. Fluid dark mode support, modern typography, and intuitive UX that puts your productivity first."
    },
    {
      icon: <Ban size={32} />,
      title: "Zero Bloatware & Minimal Friction",
      description: "We hate bloat as much as you do. Our utilities launch in milliseconds, require no unnecessary account signups, and keep workflows straightforward and fast."
    },
    {
      icon: <Sun size={32} />,
      title: "Specialized Industry Software",
      description: "Beyond everyday consumer utilities, we engineer purpose-built tools like JustSolar to eliminate spreadsheets and bring true mobility to solar EPC field operations."
    },
    {
      icon: <RefreshCw size={32} />,
      title: "Continuous Software Evolution",
      description: "Every product in our catalog receives regular updates for new Android versions, bug fixes, performance optimizations, and user-requested feature additions."
    }
  ];

  return (
    <section id="services" className="section services product-philosophy-section">
      <div className="container">
        <div className="section-header animate-on-scroll">
          <span className="section-badge">Product Philosophy</span>
          <h2 className="section-title">Engineered for Utility, Privacy & Speed</h2>
          <p className="section-subtitle">
            Every software product we build is guided by core engineering principles that prioritize user satisfaction and long-term reliability.
          </p>
        </div>
        
        <div className="services-grid">
          {pillars.map((pillar, index) => (
            <div key={index} className="service-card animate-on-scroll">
              <div className="service-icon">
                {pillar.icon}
              </div>
              <h3>{pillar.title}</h3>
              <p>{pillar.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;